export default __webpack_public_path__ + "static/media/jerry_off.4124aad6.png";